<template>
	<div
		class="pill-filter"
		:class="[
			orientation === 'vertical' ? '-vertical' : '-horizontal',
			multi ? '-multi' : '-single',
		]"
	>
		<button
			v-for="option in options"
			:key="option.value"
			class="pill-filter__pill"
			:class="{ 'is-selected': isSelected(option.value) }"
			:aria-pressed="isSelected(option.value) ? 'true' : 'false'"
			type="button"
			@click="onSelect(option.value)"
		>
			{{ option.label }}
		</button>
	</div>
</template>

<script>
export default {
	name:  'PillFilter',
	props: {
		options: {
			type:     Array,
			required: true,
		},
		value: {
			type:    [Array, String, Number, null],
			default: null,
		},
		multi: {
			type:    Boolean,
			default: false,
		},
		orientation: {
			type:      String,
			default:   'horizontal', // or 'vertical'
			validator: v => ['horizontal', 'vertical'].includes(v),
		},
	},
	methods: {
		isSelected(val) {
			if (this.multi) {
				return Array.isArray(this.value) && this.value.includes(val);
			}
			return this.value === val;
		},
		onSelect(val) {
			if (this.multi) {
				const newValue = Array.isArray(this.value) ? [...this.value] : [];
				const idx = newValue.indexOf(val);
				if (idx > -1) {
					newValue.splice(idx, 1);
				} else {
					newValue.push(val);
				}
				this.$emit('input', newValue);
				this.$emit('change', newValue);
			} else {
				// Prevent deselection - always keep one filter selected
				if (this.value !== val) {
					this.$emit('input', val);
					this.$emit('change', val);
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.pill-filter {
	display: flex;
	align-items: flex-start;
	gap: $sp3;

	&.-vertical {
		flex-direction: column;
		gap: $sp4;
	}

	&.-horizontal {
		flex-direction: row;
		flex-wrap: nowrap;
		overflow-x: auto;
		overflow-y: hidden;
		scrollbar-width: none; // Firefox
		-ms-overflow-style: none; // IE and Edge

		// Hide scrollbar for WebKit browsers
		&::-webkit-scrollbar {
			display: none;
		}
	}
}

.pill-filter__pill {
	appearance: none;
	background-color: transparent;
	color: var(--color-grey-300);
	border-radius: 999px; // stylelint-disable-line
	padding: $sp2-5 $sp3-5;
	flex-grow: 0;
	flex-shrink: 0;
	cursor: pointer;
	transition: background-color $trans-time-fast;
	outline: none;
	display: flex;
	align-items: center;
	justify-content: center;

	// Only apply word-breaking prevention to horizontal orientation
	.pill-filter.-horizontal & {
		white-space: nowrap;
		word-break: keep-all;
		overflow-wrap: normal;
	}

	&.is-selected {
		background-color: var(--color-grey-800);
		color: var(--color-white);

		body.-t-light & { // stylelint-disable-line
			background-color: var(--color-grey-850);
			color: var(--color-black);
		}
	}

	@include size(md-up) {
		padding: $sp3-5 $sp4-5;
	}
}
</style>
